// Shared date formatters — all timestamps across the app render in
// AMERICA/NEW_YORK (Eastern Time). Handles EST ↔ EDT automatically via
// Intl.DateTimeFormat so a driver logging in from anywhere sees the same
// wall-clock time as the pharmacies and dispatchers in Florida.
//
// Format standard:
//   Date  → MM/DD/YYYY
//   Time  → hh:mm AM/PM ET
//   Combo → MM/DD/YYYY hh:mm AM/PM ET
//
// The "ET" suffix keeps the timezone explicit for anyone reviewing POD
// details from another region.

const ET = "America/New_York";

function safeDate(iso) {
  if (!iso) return null;
  const d = iso instanceof Date ? iso : new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

// Extract MM, DD, YYYY, hh, mm, am/pm — all as ET wall-clock values.
function etParts(iso) {
  const d = safeDate(iso);
  if (!d) return null;
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: ET,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(d).reduce((acc, p) => (acc[p.type] = p.value, acc), {});
  return parts;
}

// MM/DD/YYYY (Eastern date)
export function fmtDate(iso) {
  const p = etParts(iso);
  if (!p) return "—";
  return `${p.month}/${p.day}/${p.year}`;
}

// MM/DD/YYYY hh:mm AM/PM ET
export function fmtDateTime(iso) {
  const p = etParts(iso);
  if (!p) return "—";
  return `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute} ${p.dayPeriod} ET`;
}

// MM/DD only (short, Eastern date)
export function fmtShortDate(iso) {
  const p = etParts(iso);
  if (!p) return "—";
  return `${p.month}/${p.day}`;
}

// hh:mm AM/PM ET
export function fmtTime(iso) {
  const p = etParts(iso);
  if (!p) return "—";
  return `${p.hour}:${p.minute} ${p.dayPeriod} ET`;
}
